import { AccommodationProviderEnum } from './enums/accommodation-provider.enum';

export class AccommodationCache {
  id?: string;
  accommodationProvider: AccommodationProviderEnum;
  '@type'?: string;
}
